<template>
  <div class="header">
    <!-- 折叠按钮 -->
    <!-- <div class="collapse-btn" @click="collapseChage">
      <i v-if="!collapse" class="el-icon-s-fold"></i>
      <i v-else class="el-icon-s-unfold"></i>
    </div> -->
    <div class="logo ellipsis">欢迎您登录医知检PC端-医学检验服务系统</div>
    <div class="header-right">
      <div class="header-user-con">
        <!-- 诊所信息 -->
        <div class="right-text">
          <span style="color: #333333; margin-right: 50px"
            >{{ clinicInfo.hsp_code ? clinicInfo.hsp_code : '' }}&nbsp; {{ clinicInfo.hsp_name ? clinicInfo.hsp_name : '' }}</span
          >
          <!-- <i class="iconfont iconqiehuanyonghu" style="font-size: 20px"></i> 切换诊所 -->
        </div>

        <!-- 全屏显示 -->
        <div class="btn-fullscreen" @click="handleFullScreen">
          <el-tooltip effect="dark" :content="fullscreen ? `取消全屏` : `全屏`" placement="bottom">
            <i class="el-icon-rank"></i>
          </el-tooltip>
        </div>
        <!-- 设置 -->
        <!-- <div class="btn-fullscreen" @click="handleFullScreen">
          <i class="iconfont iconshezhi" style="font-size: 21px"></i>
        </div> -->

        <!-- 用户头像 -->
        <div class="user-avator">
          <img
            :src="
              baseInfo.cal_Manage_avatar_address
                ? baseInfo.cal_Manage_avatar_address
                : 'https://picture.aiyizhijian.com/image/jpg/647281852755150080.jpg'
            "
          />
        </div>
        <!-- 用户名下拉菜单 -->
        <el-dropdown class="user-name" trigger="click" @command="handleCommand">
          <span class="el-dropdown-link">
            {{ username }}
            <i class="el-icon-caret-bottom"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item divided command="loginpassword">修改登录密码</el-dropdown-item>
            <!-- <el-dropdown-item divided command="paymentpassword">设置支付密码</el-dropdown-item> -->
            <!-- <el-dropdown-item divided command="secretfree">免密设置</el-dropdown-item> -->
            <el-dropdown-item divided command="querydata">2.0数据查询</el-dropdown-item>
            <el-dropdown-item divided command="feedback">意见反馈</el-dropdown-item>
            <el-dropdown-item divided command="ocrdata">OCR数据</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>
<script>
import bus from '../common/bus';
import request from '@/utils/request';
export default {
  data() {
    return {
      baseInfo: {},
      clinicInfo: {},
      collapse: false,
      fullscreen: false,
      name: '管理员',
      message: 2,
      timer: '' //定时器
    };
  },

  computed: {
    username() {
      let username = localStorage.getItem('ms_username');
      return username ? username : this.name;
    }
  },
  created() {
    if (sessionStorage.getItem('user')) {
      this.clinicInfo = JSON.parse(sessionStorage.user);
      this.getBaseClinicInfo();
    }
  },
  mounted() {
    const that = this;
    if (document.body.clientWidth < 1500) {
      this.collapseChage();
    }
    setTimeout(that.validateToken, 1000);
    that.timer = setInterval(that.validateToken, 1800000); //定时器验证token是否过期失效或者不存在
  },
  beforeDestroy(){},
  methods: {
    // 验证token
    validateToken() {
      if (sessionStorage.user) {
        const clinicInfoJy = JSON.parse(sessionStorage.user);
        if (clinicInfoJy && clinicInfoJy.token) {
          const params = {
            token: clinicInfoJy.token
          };
          request.post('/server/11.php', params).then((res) => {
            if (res.hsp_name && res.hsp_code) {
               console.log('token 可以使用');
            } else {            
              this.$message.warning('抱歉token失效，请重新登录');
              this.$router.push({ path: '/login', query: {} });
            }
          });
        } else {         
          this.$message.warning('抱歉token失效，请重新登录');
          this.$router.push({ path: '/login', query: {} });
        }
      } else {        
        this.$message.warning('抱歉token失效，请重新登录');
        this.$router.push({ path: '/login', query: {} });
      }
    },
    // 用户名下拉菜单选择事件
    handleCommand(command) {
      const Timestamp = new Date().getTime(); //时间戳
      if (command == 'loginpassword') {
        // localStorage.removeItem('ms_username');
        this.$router.push({ path: '/resetIndex', query: { word: 'loginpassword', timer: Timestamp } });
      } else if (command == 'paymentpassword') {
        this.$router.push({ path: '/resetIndex', query: { word: 'paymentpassword', timer: Timestamp } });
      } else if (command == 'secretfree') {
        this.$router.push({ path: '/resetIndex', query: { word: 'secretfree', timer: Timestamp } });
      } else if (command == 'feedback') {
        this.$router.push({ path: '/resetIndex', query: { word: 'feedback', timer: Timestamp } });
      } else if (command == 'querydata') {
        window.open('http://wehealth.hwason.cn', '_blank');
      }else if(command == 'ocrdata'){
       this.$router.push({ path: '/ocrData', query: {} });
      }
    },
    // 侧边栏折叠1
    collapseChage() {
      this.collapse = !this.collapse;
      bus.$emit('collapse', this.collapse);
    },
    // 全屏事件1
    handleFullScreen() {
      let element = document.documentElement;
      if (this.fullscreen) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      } else {
        if (element.requestFullscreen) {
          element.requestFullscreen();
        } else if (element.webkitRequestFullScreen) {
          element.webkitRequestFullScreen();
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen();
        } else if (element.msRequestFullscreen) {
          // IE11
          element.msRequestFullscreen();
        }
      }
      this.fullscreen = !this.fullscreen;
    },
    // 获取诊所基本信息
    getBaseClinicInfo() {
      const that = this;
      const clinicInfo = JSON.parse(sessionStorage.user);
      let dataP = {
        cal_code: clinicInfo.cal_code,
        DisableState: 'F'
      };
      const params = {
        token: clinicInfo.token,
        datatab: '296cxruOyduue3onJ6cL5CtrN7yxndVsAzfZ/rPujyPd1vItGUWCCA4yZIk',
        select:
          '33683I3JL7U/9MlrcChF+RXZIgMtRP/yvKnOaeGEaSehadZfiELa4+dATapSOOiznW/NnrokIA8ly4qNEkeDcTxpXnSCX6lPQkL9ik8BriGnBDghNeCSfHNCYXs2Wa/6eCqxnoLSCnkCRrZrFsj9oCa2K2VN/vO8HpzLPO835ckBuxjrg48GZpQVDvLfbmDRSusEvJFVgFSLpKBQFrGC9xW+DtFvi737nM2znXl9qAFnDHHnQU0UBbTzHfUv2W70//n9cP88lZ8FU/4QU2Tum1FP1Q',
        obgb: '88a4ufqmzpSyAKIfHrBbB1uD/QWSBC/+oi+zz3CbVpWEqL0ItLawFE2euvDd99dLnq/84OGX+P89lCbgNXre8xGgIxGy/z/fQls',
        LIKE: 'nl',
        data: JSON.stringify(dataP)
      };
      request
        .post('/server/getkehulbapi.php', params)
        .then((res) => {
          that.baseInfo = res[0];
        })
        .catch((err) => {});
    }
  }
};
</script>
<style scoped>
.header {
  position: relative;
  z-index: 8;
  box-sizing: border-box;
  width: 100vw;
  margin-left: -128px;
  height: 70px;
  font-size: 22px;
  color: #fff;
  background-color: #fff;
  box-shadow: 0px 5px 6px 0px rgba(0, 0, 0, 0.03);
  border-radius: 0px 0px 30px 30px;
  display: flex;
  justify-content: space-between;
}
.collapse-btn {
  float: left;
  padding: 0 21px;
  cursor: pointer;
  line-height: 70px;
}
/* 标题区域 */
.header .logo {
  line-height: 70px;
  font-size: 20px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #999999;
  /* border: 1px solid red; */
  box-sizing: border-box;
  padding-left: 150px;
}
.header-right {
  flex-shrink: 0;
  padding-right: 50px;
  /* border: 1px solid rgb(81, 255, 0); */
}
/* 切换诊所 */
.right-text {
  line-height: 70px;
  font-size: 15px;
  font-family: Source Han Sans CN;
  font-weight: 600;
  color: #36b6ff;
  /* border: 1px solid red; */
  box-sizing: border-box;
  padding-right: 50px;
  cursor: pointer;
  user-select: none;
}
.header-user-con {
  display: flex;
  height: 70px;
  align-items: center;
}
.btn-fullscreen {
  transform: rotate(45deg);
  margin-right: 5px;
  font-size: 24px;
}

.btn-fullscreen {
  position: relative;
  width: 30px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  border-radius: 15px;
  cursor: pointer;
  color: #8ca0ac;
  /* border: 1px solid red; */
}

.user-name {
  margin-left: 10px;
  color: #8ca0ac;
}
.user-avator {
  margin-left: 20px;
}
.user-avator img {
  display: block;
  width: 40px;
  height: 40px;
  border-radius: 50%;
}
.el-dropdown-link {
  color: #8ca0ac;
  cursor: pointer;
}
.el-dropdown-menu__item {
  text-align: center;
}
</style>
